import { render, staticRenderFns } from "./SecondSection.vue?vue&type=template&id=1b9a70c9"
import script from "./SecondSection.vue?vue&type=script&lang=js"
export * from "./SecondSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports